import styled from "styled-components";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";

export const TableWrapper = styled.div`
  width: 100%;
  max-width: 1376px;
  margin: auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${(props) => {
    if (props.theme.mode === "dark") {
      return `
          .p-paginator {
            background: ${props.theme.searchPatients.table.bg};
            
            & * {
              color: ${props.theme.pageTables.text};
            }
          }
      `;
    }
  }}
`;

export const Table = styled(DataTable)`
  & thead tr th {
    padding: 15px 0;
    background: ${({ theme }) => theme.searchPatients.table.bg};
    color: ${({ theme }) => theme.searchPatients.input.text};
    border: 1px solid ${({ theme }) => theme.searchPatients.controls.tabOutline};
    border-width: 0 0 1px 0;

    & .p-column-title {
      margin-right: 10px;
    }

    & .p-sortable-column-icon,
    & .table-sort-icon {
      display: inline-flex;
      align-items: center;
      margin-left: 10px;
      vertical-align: middle;
    }
  }

  & tbody tr td {
    padding: 12px 0;
    background: ${({ theme }) => theme.searchPatients.table.bg};
    color: ${({ theme }) => theme.searchPatients.input.text};
    border: 1px solid ${({ theme }) => theme.searchPatients.controls.tabOutline};
    border-width: 0 0 1px 0;
  }

  && .p-datatable-tbody > tr:hover > td {
    background: #f8f8f8;
  }
`;

export const PageSearchInput = styled.input`
  height: 38px;
  min-width: 220px;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.searchPatients.controls.tabOutline};
  border-radius: 8px;
  background: #ffffff;
  color: ${({ theme }) => theme.searchPatients.input.text};
  font-size: 14px;
  line-height: 20px;

  &::placeholder {
    color: #5a5959;
  }

  &:focus {
    outline: none;
    border-color: #065fa6;
    box-shadow: 0 0 0 1px rgba(6, 95, 166, 0.12);
  }
`;

export const PaginatorBtn = styled.button`
  background: none;
  border: none;
  padding: 15px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gray};
  margin: 5px;

  &:disabled {
    color: #9fa0a4;
  }

  &:hover {
    color: black;
    background-color: blue;
    border-radius: 4px;
  }
`;

export const PageReportTitle = styled.span`
  color: black;
  user-select: none;
  text-align: center;
  position: absolute;
  left: 0px;
`;

export const RowsPerPageWrapper = styled.div`
  position: absolute;
  right: 0px;
  display: inline-flex;
  align-items: center;
`;

export const RowsPerPage = styled(Dropdown)`
  min-width: 76px;

  &.p-dropdown {
    height: 38px;
    border: 1px solid ${({ theme }) => theme.searchPatients.controls.tabOutline};
    border-radius: 8px;
    box-shadow: none;
  }

  & .p-dropdown-label {
    padding: 8px 8px 8px 12px;
    color: ${({ theme }) => theme.searchPatients.input.text};
    font-size: 14px;
    line-height: 20px;
  }

  & .p-dropdown-trigger {
    width: 32px;
    color: #5a5959;
  }

  &:not(.p-disabled).p-focus,
  &:not(.p-disabled):hover {
    border-color: #065fa6;
    box-shadow: 0 0 0 1px rgba(6, 95, 166, 0.12);
  }

  ${(props) => {
    if (props.theme.mode === "dark") {
      return `
        background: ${props.theme.searchPatients.table.bg};
      `;
    }
  }}
`;
